(() => {
  angular.module('finance').component('invoiceDetailStatementSummaryComponent', {
    templateUrl: require('./statementSummary.component.html'),
    controller: InvoiceDetailStatementSummaryComponent,
    controllerAs: 'vm',
    bindings: {
      currencyCode: '<',
      invoice: '<',
      invoiceFrom: '<',
      invoiceTo: '<',
      isAddressInvoiceFrom: '<',
      isAddressInvoiceTo: '<',
      message: '<',
      getDateString: '<'
    },
  });

  InvoiceDetailStatementSummaryComponent.$inject = [];

  function InvoiceDetailStatementSummaryComponent() {
    const vm = this;

    vm.loading = 0;

    init();

    function init() {}
  }
})();
